// extracted by mini-css-extract-plugin
export default {"import":"MeterReadingImport_import__AEPFz"};